import { Text } from 'ui';

const { Stack } = require('@koob/margaret');
import styled from 'styled-components';
import { HotelTag } from 'components/Hotel/HotelDetails/Base';

const SectionTitle = styled(Text).attrs({ type: 'h2' })`
  font-weight: 700;
  margin-top: 20px;
`;

const Tags = ({ tags }) =>
  tags.map((tag, index) => (
    <div className="rounded-full" key={index}>
      <HotelTag>
        <div className="text-xs font-extrabold uppercase leading-none m-0">
          {tag}
        </div>
      </HotelTag>
    </div>
  ));

// `tags`: one unlabeled row. `tagGroups`: [{ label, tags }], one labeled row
// each, so different kinds of tags can be told apart; empty groups are hidden.
const KoobHeader = ({ title, tags = [], tagGroups = [], children }) => {
  const groups = tagGroups.filter(group => group.tags.length > 0);

  return (
    <>
      <Stack direction="column">
        <SectionTitle>{title}</SectionTitle>
      </Stack>

      <div className="flex flex-wrap">
        <Stack
          gutterSize={1.5}
          alignX="space-between"
          style={{ marginTop: '10px' }}
        >
          <Stack direction="row" gutterSize={1.5}>
            <Stack direction="row" gutterSize={2} alignY="center">
              {children}
            </Stack>
          </Stack>
        </Stack>
      </div>
      <div>
        {tags.length > 0 && (
          <div className="my-4 flex flex-wrap items-center gap-3">
            <Tags tags={tags} />
          </div>
        )}
        {groups.length > 0 && (
          <div className="my-4 flex flex-col gap-2">
            {groups.map(group => (
              <div
                key={group.label}
                className="flex flex-wrap items-center gap-3"
              >
                <span className="text-sm text-gray-500">{group.label}</span>
                <Tags tags={group.tags} />
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};
export default KoobHeader;
